import * as appStoreActions from '../../actions/appStoreActions';

/**
 * Each list tab's install count opens the list of exactly the rows it counted: All Apps counts every
 * install of the app, Manage App Adverts only the installs that advert placed (UN-3372 item 4). Linking
 * the advert count to the app's list showed "installed on 3 stores" under a count of 2 (UN-3252 QA).
 *
 * `subject` picks the thing the heading names out of the appStore slice — a reference the store already
 * holds, so a selector over it stays stable — and its `installCount` is the same set the list pages, so
 * the heading can show it until the first page lands. `load` fetches it only when it is missing.
 */
export const INSTALLED_SITES_SCOPES = {
  app: {
    subject: (appStore, uuid) => (appStore.app && appStore.app.uuid === uuid ? appStore.app : null),
    load: appStoreActions.getApp,
    loadSites: appStoreActions.getInstalledSites,
    backTo: '/manage-apps/apps',
    label: 'App',
    none: 'This app is not installed anywhere yet.'
  },
  advert: {
    // The Manage App Adverts ROW, not the advert detail: the detail's installCount is the linked app's
    // total — a different set — and fetching it would write into the edit form's advert slot. The tab
    // holds a Spring page since UN-3339, so the row is looked up in its `content`.
    subject: (appStore, uuid) => (appStore.adverts.content || []).find(advert => advert.uuid === uuid) || null,
    // A pasted link lands with no list loaded: load its first page, as the tab itself would. An advert
    // past that page keeps the generic heading; its sites and count still load, by uuid.
    load: () => appStoreActions.getAdverts(),
    loadSites: appStoreActions.getAdvertInstalledSites,
    backTo: '/manage-apps/adverts',
    label: 'Advert',
    none: 'No store has installed this app through this advert yet.'
  }
};

/**
 * Where an advert row's install count leads, or null when there is nothing to list. Keyed on the count,
 * not on a linked app: the advert's installs stay listable after it is unlinked.
 */
export const advertInstalledSitesPath = advert =>
  advert.installCount > 0 ? `/manage-apps/adverts/${advert.uuid}/installed-sites` : null;
